import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import capitalize from 'lodash/capitalize'
import {hideLoader} from 'app/redux/loaderSlice'
import CustomerPaymentDialog from './CustomerPaymentDialog'
import {draftOrderTypes} from '../../models'

type Props = {
  paymentMethod: any
  title: string
  customerId?: any
  orderStatus: any
}

const Payment: FC<Props> = ({paymentMethod, title, customerId, orderStatus}) => {
  const dispatch = useDispatch()
  const [showDialog, setShowDialog] = useState(false)

  const handleShowPayment = () => {
    setShowDialog(true)
    dispatch(hideLoader())
  }

  const handleClosePayment = () => {
    setShowDialog(false)
    dispatch(hideLoader())
  }

  return (
    <>
      <div className='d-flex flex-column mb-4'>
        <div className='d-flex align-items-center fs-5 fw-bolder mb-5 justify-content-between'>
          {title}
          {orderStatus === draftOrderTypes.open && (
            <button
              id='btnCusPayEdit'
              className='btn btn-sm btn-link'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_new_pay'
              onClick={handleShowPayment}
            >
              Change
            </button>
          )}
        </div>
        {paymentMethod && paymentMethod.card && (
          <div className='d-flex flex-column'>
            <div className='fs-6 fw-bold text-gray-600'>
              {`${capitalize(paymentMethod.card.brand)} **** ${paymentMethod.card.last4}`}
              <br />
              {paymentMethod.card.expMonth}/{paymentMethod.card.expYear}
            </div>
          </div>
        )}
      </div>
      {showDialog && (
        <CustomerPaymentDialog
          onClose={handleClosePayment}
          customerId={customerId}
          selectedPayment={paymentMethod.id}
        />
      )}
    </>
  )
}

export default Payment
